import { Component, ReactNode } from "react"

import {
  getSortTermLocalStorage,
  setSortTermLocalStorage,
} from "utils/expirableLocalStorage"

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  //   error: Error | null;
}

class GlobalErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
      //   error: null,
    }
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(
    error: Error,
    // errorInfo: ErrorInfo
  ): void {
    // console.error('Error caught by Error Boundary:', error, "------------");

    // Check for chunk load error and refresh the page
    if (error && error?.name && error?.name === "ChunkLoadError") {
      // console.warn('Chunk load error detected, refreshing the page...', error);
      const isRepeated = getSortTermLocalStorage("isChunkLoadErrorHost") || null
      if (isRepeated) {
        return
      }
      setSortTermLocalStorage("isChunkLoadErrorHost", "true", 300)
      window.location.reload()
    }
  }

  render(): ReactNode {
    const { hasError } = this.state
    const { children } = this.props
    if (hasError) {
      return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {/* <h1>Something went wrong.</h1> */}
        </div>
      )
    }

    return children
  }
}

export default GlobalErrorBoundary
